import { BarChart3 } from "lucide-react";
import { formatDuration } from "./utils";
import { zoneColors } from "./utils";

const DwellTimesChart = ({ dwellTimes }) => {
  if (!dwellTimes || Object.keys(dwellTimes).length === 0) {
    return (
      <div className="reid-empty-state">
        No dwell time data available
      </div>
    );
  }

  const maxTime = Math.max(...Object.values(dwellTimes));

  return (
    <div className="reid-card">
      <h4 className="reid-card-header">
        <BarChart3 size={18} className="reid-card-header-icon" />
        Average Dwell Times by Zone
      </h4>
      <div className="reid-dwell-chart">
        {Object.entries(dwellTimes).map(([zone, avgTime]) => (
          <div key={zone} className="reid-dwell-item">
            <span className="reid-dwell-label">
              {zone}
            </span>
            <div className="reid-dwell-bar-container">
              <div
                className="reid-dwell-bar"
                style={{
                  width: `${(avgTime / maxTime) * 100}%`,
                  backgroundColor: zoneColors[zone] || zoneColors.default,
                }}
              />
              <span className="reid-dwell-bar-label">
                {formatDuration(avgTime)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DwellTimesChart; 